import type { Fonts } from '../../types'
import {
  SbFontFamilyBold,
  SbFontFamilyMedium,
  SbFontFamilyRegular,
} from './generated-tokens/ts/font-family'
import {
  SbFontNameBold,
  SbFontNameMedium,
  SbFontNameRegular,
} from './generated-tokens/ts/font-names'

export const fonts: Fonts = {
  regular: {
    name: SbFontNameRegular,
    family: SbFontFamilyRegular,
  },
  medium: {
    name: SbFontNameMedium,
    family: SbFontFamilyMedium,
  },
  bold: {
    name: SbFontNameBold,
    family: SbFontFamilyBold,
  },
}
